/** Schritt 2 „Kandidaten“ inkl. Blacklist. */
const wizCandDE = {
  wizCandTitle: 'Woher kommen die Kandidaten?',
  wizCandSubtitle: 'Meist reicht die Suche von SAIA. Du kannst auch eine eigene Suche mitbringen.',
  wizCandMethodSaiaTitle: 'SAIA sucht für dich',
  wizCandMethodSaiaDesc: 'Empfohlen. Wir bauen die LinkedIn-Suche aus deinem Briefing.',
  wizCandMethodUrlTitle: 'Eigene LinkedIn-Suche',
  wizCandMethodUrlDesc: 'Link einer Suche aus LinkedIn, Sales Navigator oder Recruiter.',
  wizCandDerived: 'Aus deinem Briefing abgeleitet',
  wizCandRederiveHint: 'Die Anzeige hat sich geändert – Suchkriterien neu aus der Anzeige ableiten?',
  wizCandRederiveButton: 'Neu ableiten',
  wizCandRederiveBusy: 'Leite ab …',
  wizCandRederiveKeep: 'Beibehalten',
  wizCandRederiveError: 'Die Ableitung ist fehlgeschlagen. Deine Angaben bleiben unverändert.',
  wizCandAdjust: 'Anpassen',
  wizCandAdjustDone: 'Fertig',
  wizCandLocations: 'Orte',
  wizCandAddLocation: '+ Ort',
  wizCandLocationPlaceholder: 'Ort suchen …',
  wizCandLocationHint: 'Wähle Orte aus der LinkedIn-Ortssuche (Stadt, Bundesland oder Region) · Radius anklicken zum Ändern',
  wizCandLocationHintPlain: 'Wähle Orte aus der LinkedIn-Ortssuche (Stadt, Bundesland oder Region)',
  wizCandCritJobTitles: 'Jobtitel',
  wizCandCritExperience: 'Weitere Suchparameter',
  wizCandCritIndustries: 'Branche',
  wizCandIndustryPlaceholder: 'Branche suchen …',
  wizCandIndustryNone: 'Keine passende Branche',
  wizCandIndustryMax: 'Höchstens {{count}} Branchen',
  wizCandIndustryHint: 'Mehrfachauswahl wie bei LinkedIn. SAIA wählt sie aus der Stellenbeschreibung vor – du kannst ergänzen, ändern und löschen.',
  wizCandLocModeCity: 'Ort',
  wizCandLocModePostal: 'PLZ + Umkreis',
  wizCandAddPostal: '+ PLZ',
  wizCandPostalPlaceholder: 'PLZ oder Stadt …',
  wizCandPostalNone: 'Keine PLZ bei LinkedIn gefunden',
  wizCandPostalHint: 'Suche eine PLZ (oder Stadt) und wähle den LinkedIn-Eintrag · Umkreis anklicken zum Ändern (wie in LinkedIn)',
  wizCandRadiusOption: '+ {{km}} km',
  wizCandRadiusNote: 'Dein Konto kann keinen Radius: gesucht wird immer in der ganzen Region. Eine Umkreissuche mit PLZ gibt es nur mit Sales Navigator oder Recruiter.',
  wizCandRadiusNotePostal: 'Bei „Ort“ wird die ganze Region durchsucht. Für einen Umkreis wähle „PLZ + Umkreis“.',
  wizCandRadiusWholeRegion: 'Ganze Region',
  wizCandRadiusWholeRegionOption: 'Ganze Region (ohne Radius)',
  wizCandLocationConfirm: '{{city}} – bitte bestätigen',
  wizCandLocationConfirmTitle: 'Dieser Ort wurde noch nicht bei LinkedIn bestätigt. Klicke, um den passenden LinkedIn-Ort zu wählen.',
  wizCandGeoMinChars: 'Mindestens zwei Zeichen eingeben',
  wizCandGeoNone: 'Kein Ort bei LinkedIn gefunden',
  wizCandGeoLoading: 'LinkedIn sucht …',
  wizCandGeoSession: 'Die LinkedIn-Sitzung ist abgelaufen. Bitte verbinde das Konto neu.',
  wizCandGeoFailed: 'Die Ortssuche ist gerade nicht erreichbar. Bitte versuche es noch einmal.',
  wizCandGeoNoAccount: 'Wähle zuerst in Schritt 1 ein LinkedIn-Konto.',
  wizCandGeoRegionTag: 'Region',
  wizCandCritLanguages: 'Sprache',
  wizCandAddCriterion: '+ Hinzufügen',
  wizCandCriterionPlaceholder: 'Eintrag + Enter',
  wizCandCriteriaEmpty: 'Noch nichts abgeleitet',
  wizCandUrlLabel: 'Link zur LinkedIn-, Sales-Navigator- oder Recruiter-Suche',
  wizCandUrlPlaceholder: 'https://www.linkedin.com/search/results/people/…',
  wizCandUrlInvalid: 'Das ist kein LinkedIn-Link.',
  wizCandUrlsLabel: 'Links zu deinen Suchen',
  wizCandUrlRowLabel: 'Link {{n}}',
  wizCandUrlRemove: 'Link {{n}} entfernen',
  wizCandUrlAdd: 'Weiteren Link hinzufügen',
  wizCandUrlMax: 'bis zu {{count}} Links',
  wizCandUrlsTotal_one: 'Zusammen ca. {{formatted}} Treffer aus {{count}} funktionierenden Link',
  wizCandUrlsTotal_other: 'Zusammen ca. {{formatted}} Treffer aus {{count}} funktionierenden Links',
  wizCandUrlsWorking_one: '{{count}} Link wird verwendet',
  wizCandUrlsWorking_other: '{{count}} Links werden verwendet',
  wizCandUrlsSplit:
    'Die ersten 50 Kandidaten werden auf die Links verteilt (je ca. {{share}}). Wer in mehreren Suchen auftaucht, zählt nur einmal. Links mit Fehler werden beim Start übersprungen.',
  wizCandUrlChecking: 'Link wird bei LinkedIn geprüft …',
  wizCandUrlWorks: 'Link funktioniert — LinkedIn liefert Treffer. Die genaue Zahl wird nach dem Start gezählt.',
  wizCandUrlWorksCount_one: 'Link funktioniert — {{formatted}} Treffer bei LinkedIn.',
  wizCandUrlWorksCount_other: 'Link funktioniert — {{formatted}} Treffer bei LinkedIn.',
  wizCandBlacklistTitle: 'Blacklist',
  wizCandBlacklistDesc:
    'Diese Firmen und Personen werden nie angesprochen – egal, ob sie aus der SAIA-Suche oder deiner eigenen Suche kommen.',
  wizCandLists: 'Deine Blacklists',
  wizCandPastEmployers: 'Auch frühere Arbeitgeber',
  wizCandPastEmployersHint: 'Sperrt jeden, der irgendwann bei einer dieser Firmen gearbeitet hat – nicht nur aktuelle Mitarbeitende.',
  wizCandSearchLocked: 'Die Suche läuft bereits und wird hier nur angezeigt. Die Blacklists darunter kannst du ändern.',
  wizCandListsEmpty: 'Es gibt noch keine Blacklist. Lege unten eine neue an.',
  wizCandNewBlacklist: 'Neue Blacklist anlegen',
  wizCandGlobalListsLoading: 'Listen werden geladen …',
  wizCandGlobalListsError: 'Die Blacklists konnten nicht geladen werden.',
  wizCandCountCompanies: 'Firmen',
  wizCandCountContacts: 'Kontakte',
  wizCandCountCompany: 'Firma',
  wizCandCountContact: 'Kontakt',
};
export default wizCandDE;
